// extracted by mini-css-extract-plugin
export var wordContainer = "_mb-0";